var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm.isSuperUser ? _c('router-link', {
    attrs: {
      "to": "/auctions/create"
    }
  }, [_c('a-button', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "primary"
    }
  }, [_c('i', {
    staticClass: "fe fe-shopping-bag font-size-15",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "title": "Schedule new auction"
    }
  }), _vm._v(" Schedule new auction ")])], 1) : _vm._e()], 1), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "16px"
    }
  }, [_c('a-input-search', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "Search auctions...",
      "allowClear": ""
    },
    on: {
      "search": _vm.onSearch,
      "pressEnter": _vm.onSearch
    },
    model: {
      value: _vm.searchText,
      callback: function callback($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  })], 1), _c('a-spin', {
    attrs: {
      "spinning": _vm.working
    }
  }, [_c('a-table', {
    attrs: {
      "columns": _vm.columns,
      "dataSource": _vm.auctions,
      "pagination": _vm.pagination,
      "loading": _vm.working
    },
    on: {
      "change": _vm.handleTableChange
    },
    scopedSlots: _vm._u([{
      key: "type",
      fn: function fn(text) {
        return [_c('a', {
          staticClass: "btn btn-sm btn-light",
          attrs: {
            "href": "javascript: void(0);"
          }
        }, [_vm._v(_vm._s(text))])];
      }
    }, {
      key: "name",
      fn: function fn(text) {
        return [_c('a', {
          staticClass: "btn btn-sm btn-light",
          attrs: {
            "href": "javascript: void(0);"
          }
        }, [_vm._v(_vm._s(text))])];
      }
    }, {
      key: "id",
      fn: function fn(text, record) {
        return _c('router-link', {
          attrs: {
            "to": '/auctions/' + record.id + '/live'
          }
        }, [_c('a', {
          staticClass: "btn btn-sm btn-light",
          attrs: {
            "href": "javascript: void(0);"
          }
        }, [_vm._v(_vm._s(text))])]);
      }
    }, {
      key: "shipping",
      fn: function fn(text) {
        return _c('span', {}, [_vm._v("$" + _vm._s(text))]);
      }
    }, {
      key: "status",
      fn: function fn(text) {
        return _c('span', {
          class: _vm.statusClasses(text)
        }, [_vm._v(_vm._s(text))]);
      }
    }, {
      key: "startsAt",
      fn: function fn(text) {
        return _c('span', {}, [_vm._v(_vm._s(_vm.moment(text).format('DD.MM.YYYY HH:mm')))]);
      }
    }, {
      key: "endsAt",
      fn: function fn(text) {
        return _c('span', {}, [_vm._v(_vm._s(_vm.moment(text).format('DD.MM.YYYY HH:mm')))]);
      }
    }, {
      key: "action",
      fn: function fn(record) {
        return _c('span', {}, [_c('a-space', {
          attrs: {
            "space": 16
          }
        }, [_c('router-link', {
          attrs: {
            "to": '/auctions/' + record.id + '/live'
          }
        }, [_c('a-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          }
        }, [_c('i', {
          staticClass: "fe fe-arrow-up-right mr-2"
        }), _vm._v(" Open ")])], 1), record.status != 'live' && _vm.isSuperUser ? _c('a', {
          staticClass: "text-danger",
          on: {
            "click": function click() {
              return _vm.deleteAuction(record.id);
            }
          }
        }, [_c('i', {
          staticClass: "fe fe-trash mr-2"
        })]) : _vm._e()], 1)], 1);
      }
    }])
  })], 1)], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }